import { BadgeComposition } from '@codeleap/web'
import { textVariant } from './Text'
import { StyleRegistry } from '../styles'
import { createStyles } from '@codeleap/styles'

const createBadgeVariant = createStyles<BadgeComposition>

export const BadgeStyles = {
  default: createBadgeVariant((theme) => ({
    wrapper: {
      ...theme.presets.absolute,
      top: theme.spacing.value(0),
      left: theme.spacing.value(0),
      backgroundColor: theme.baseColors.redSolid400,
      borderRadius: theme.radius.infinite,
    },
    innerWrapper: {
      ...theme.presets.center,
      borderRadius: theme.radius.infinite,
    },
    count: {
      ...textVariant('p5'),
      ...theme.presets.textCenter,
      color: theme.baseColors.neutralSolid0,
    },
  })),
  border: createBadgeVariant((theme) => ({
    wrapper: {
      ...theme.sized(2.5),
      backgroundColor: theme.baseColors.neutralSolid0,
    },
    innerWrapper: {
      ...theme.sized(1.5),
      backgroundColor: theme.baseColors.redSolid400,
    },
  })),
  'position:leftTop': createBadgeVariant((theme) => ({
    wrapper: {
      ...theme.presets.absolute,
      top: -theme.spacing.value(0.5),
      left: -theme.spacing.value(0.5),
      zIndex: 2,
    },
  })),
  'position:leftBottom': createBadgeVariant((theme) => ({
    wrapper: {
      ...theme.presets.absolute,
      bottom: -theme.spacing.value(0.5),
      left: -theme.spacing.value(0.5),
      zIndex: 2,
    },
  })),
  'position:rightTop': createBadgeVariant((theme) => ({
    wrapper: {
      ...theme.presets.absolute,
      top: -theme.spacing.value(0.5),
      right: -theme.spacing.value(0.5),
      zIndex: 2,
    },
  })),
  'position:rightBottom': createBadgeVariant((theme) => ({
    wrapper: {
      ...theme.presets.absolute,
      bottom: -theme.spacing.value(0.5),
      right: -theme.spacing.value(0.5),
      zIndex: 2,
    },
  })),
  'highlighted': createBadgeVariant((theme) => {
    const size = theme.size.regular

    return ({
      wrapper: {
        minHeight: size / 2,
        maxHeight: size,
        backgroundColor: theme.colors.buttonHighlightPrimaryBgDefault,
        borderRadius: theme.radius.infinite,
      },
      innerWrapper: {
        minHeight: size / 2,
        maxHeight: size,
        borderRadius: theme.radius.infinite,
        ...theme.spacing.py(0.2),
        ...theme.spacing.px(1),
        color: 'rgba(255, 255, 255, 1)',
      },
    })
  }),
  'number': createBadgeVariant((theme) => {
    return ({
      wrapper: {
        minHeight: theme.size.medium,
        maxHeight: theme.size.medium,
        minWidth: theme.size.large,
        maxWidth: theme.size.large,
        backgroundColor: theme.baseColors.redSolid500,
        borderRadius: theme.radius.infinite,

      },
      innerWrapper: {
        ...theme.presets.fullWidth,
      },
    })
  }),
  'numberSmall': createBadgeVariant((theme) => {
    return ({
      wrapper: {
        minHeight: theme.size.regular,
        maxHeight: theme.size.regular,
        minWidth: theme.size.regular,
        backgroundColor: theme.baseColors.redSolid500,
        border: `2px solid ${theme.baseColors.neutralSolid0}`,
        borderRadius: theme.radius.infinite,
      },
      innerWrapper: {
        ...theme.presets.fullWidth,
      },
    })
  }),
  'numberSmall:selected': createBadgeVariant((theme) => {
    return ({
      wrapper: {
        border: `2px solid ${theme.baseColors.primarySolid50}`,
      },
    })
  }),
}

StyleRegistry.registerVariants('Badge', BadgeStyles)
